import { render } from "./LogoBox.vue?vue&type=template&id=695f5d46"
import script from "./LogoBox.vue?vue&type=script&lang=js"
export * from "./LogoBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__